export default __webpack_public_path__ + "static/media/login-illustration.58d9e7d5.svg";